import { Format, useTranslation } from '../util';
import { FormattableValue } from '../util/translate';

export interface FormatValueProps {
  /**
   * Value to format
   */
  value: FormattableValue;
  /**
   * Format to use. Consider one of the constants attached to this component.
   */
  format?: Format;
}

/**
 * Format numbers and dates using our standard i18n functionality.
 */
export const FormatValue = ({ value, format }: FormatValueProps) => {
  const { i18n } = useTranslation();
  return <>{i18n.format(value, format)}</>;
};
